import React, { useState, useContext } from "react";
import { roles } from "../Mappings";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { AppStateContext } from "../Contexts/AppStateContext";
import { UserDataContext } from "../Contexts/UserDataContext";
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom";
import SettingsIcon from "@material-ui/icons/Settings";
import version from "../version.json";
import GroupIcon from "@material-ui/icons/Group";

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: "bold",
  },
  version: {
    position: "absolute",
    bottom: "5px",
    left: "5px",
  },
}));

const SideMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const { appState, setAppState } = useContext(AppStateContext);
  const { userData, setUserData, logout } = useContext(UserDataContext);

  return (
    <Drawer
      anchor="left"
      open={appState.menuOpen}
      onClose={() => setAppState({ ...appState, menuOpen: false })}
    >
      <List>
        <ListItem>
          <Typography
            color="primary"
            className={classes.header}
            variant="body1"
          >
            Team Global Express NZ Owner Driver Portal
          </Typography>
        </ListItem>
        <Divider />
        <ListItem>
          <ListItemText primary={`Logged in as ${userData.userName}`} />
        </ListItem>
        <ListItem>
          <ListItemText primary={`Role - ${roles[userData.roleId]}`} />
        </ListItem>
        <Divider />

        <ListItem
          button
          onClick={() => history.push(`/${userData.userName}/settings`)}
        >
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary={"Settings"} />
        </ListItem>
        <ListItem button onClick={logout}>
          <ListItemIcon>
            <MeetingRoomIcon />
          </ListItemIcon>
          <ListItemText primary={"Log out"} />
        </ListItem>
        <Divider />

        {userData.roleId === roles.tollSystemAdmin && (
          <ListItem
            button
            onClick={() => {
              history.push(`/${userData.userName}/master-data`);
              setAppState({ ...appState, menuOpen: false });
            }}
          >
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText>Master Data Management</ListItemText>
          </ListItem>
        )}
      </List>
      <Typography variant="caption" className={classes.version}>
        {version.commit.substring(0, 7)}
      </Typography>
    </Drawer>
  );
};

export default SideMenu;
